/*!
 * ETAR theme v4.2.4 — Global helpers
 * Developed by FACTICIED · https://www.facticied.com
 */
(() => {
  if (window.Etar) return;
  const R = (window.Etar = {});

  /* Keep focus inside an open panel (drawer, search) */
  R.trapFocus = (box) => {
    const sel = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
    const onKey = (e) => {
      if (e.key !== 'Tab') return;
      const items = Array.from(box.querySelectorAll(sel)).filter((el) => el.offsetParent !== null);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    box.addEventListener('keydown', onKey);
    return () => box.removeEventListener('keydown', onKey);
  };

  R.lockScroll = (on) => document.body.classList.toggle('is-locked', !!on);

  R.money = (cents) => {
    try { return (cents / 100).toLocaleString(document.documentElement.lang || undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PKR' }); }
    catch (e) { return (cents / 100).toFixed(2); }
  };

  /* Scroll reveal for elements with .et-reveal */
  const reveal = () => {
    if (!document.documentElement.classList.contains('et-reveal-on')) return;
    const els = document.querySelectorAll('.et-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
  };
  R.reveal = reveal;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal); else reveal();
  document.addEventListener('shopify:section:load', reveal);
})();
